module.exports = __webpack_public_path__ + "static/img/rencai.0e35e447.png";